export default __webpack_public_path__ + "static/banner_background-94882004c9aeab97f1c764fd6e939513.jpg";